import React, { useState, useEffect, Component } from "react";
import Cookies from "js-cookie";
import BASE_URL from "../config";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../TableView";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SelectDropdown from "../SelectDropdown";

const Ports = (props) => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  const [pageComponent, setPageComponent] = useState("ports");
  const [data, setData] = useState(undefined);
  const [cCode, setCCode] = useState("");
  const [cID, setCID] = useState("");
  const [countryDesc, setcountryDesc] = useState("");
  const [protCode, setProtCode] = useState("");
  const [protDesc, setProtDesc] = useState("");
  const [protIntCode, setprotIntCode] = useState("");
  const [countryList, setCountryList] = useState(undefined);
  const [btnActive, setBtnActive] = useState(true);
  const [selectRowData, setSelectRowData] = useState("");
  const [emptyCountry, setEmptyCountry] = useState(false);
  const [emptyProtCode, setEmptyProtCode] = useState(false);
  const [emptyPortName, setEmptyPortName] = useState(false);
  const [emptyInputProtCodeXML, setEmptyInputProtCodeXML] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);
  let [duplicateVal, setDuplicateVal] = useState(false);

  const createNewRow = () => {
    setBtnActive(false);
    setSelectRowData("");
  };

  const setCountryCode = (event) => {
    setCID(event.value);
    setCCode(event.value);
    setcountryDesc(event.label);
  };

  function setSelectedRow(rowid) {
    setBtnActive(false);
    axios
      .get(`${BASE_URL}${pageComponent}/single/${rowid}`, {
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
      .then((res) => {
        setCountryList(undefined);
        setSelectRowData(res.data);
        setcountryDesc(
          selectRowData.ports.country_code
            ? selectRowData.ports.country_code
            : ""
        );
        setProtCode(
          selectRowData.ports.port_code ? selectRowData.ports.port_code : ""
        );
        setProtDesc(
          selectRowData.ports.port_description
            ? selectRowData.ports.port_description
            : ""
        );
        setprotIntCode(
          selectRowData.ports.international_port_code
            ? selectRowData.ports.international_port_code
            : ""
        );
        setCCode(
          selectRowData.ports.country_code
            ? selectRowData.ports.country_code
            : ""
        );
      });
  }

  useEffect(() => {
    fetch(`${BASE_URL}countries/dropdown`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setCountryList(data.countries);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [authtoken]);

  useEffect(() => {
    fetch(`${BASE_URL}${pageComponent}/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data.ports);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [authtoken, pageComponent]);

  const handleSave = async (event) => {
    event.preventDefault();
    if (cCode.length === 0) {
      toast.error("Country Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyCountry(true);
      setEmptyInput(true);
    } else {
      setEmptyCountry(false);
    }

    if (protCode.length === 0) {
      toast.error("Port Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyProtCode(true);
      setEmptyInput(true);
    } else {
      setEmptyProtCode(false);
    }

    if (protDesc.length === 0) {
      toast.error("Port Name can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyPortName(true);
      setEmptyInput(true);
    } else {
      setEmptyPortName(false);
    }

    if (protIntCode.length === 0) {
      toast.error("Port Code For XML can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyInputProtCodeXML(true);
      setEmptyInput(true);
    } else {
      setEmptyInputProtCodeXML(false);
    }

    if (emptyInput !== true) {
      const inputData = {
        CuntCode: cCode,
        PortCode: protCode,
        PortDesc: protDesc,
        IntPortCode: protIntCode,
      };
      const duplicate = await data.some((el) => el.PortCode === protCode);
      if (duplicate !== true) {
        axios
          .post(`${BASE_URL}${pageComponent}/store`, inputData, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          })
          .then((response) => {
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setTimeout(window.location.reload.bind(window.location), 2000);
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        toast.error("This Port code already included", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
    }
  };

  const edditRow = (event) => {
    event.preventDefault();
    if (selectRowData !== "") {
      const inputData = {
        CuntCode: cCode,
        PortCode: protCode,
        PortDesc: protDesc,
        IntPortCode: protIntCode,
      };
      axios
        .post(
          `${BASE_URL}${pageComponent}/${selectRowData[0].id}/update`,
          inputData
        )
        .then((response) => {
          toast.success("Successfully Save Data ! ", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setTimeout(window.location.reload.bind(window.location), 2000);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      toast.error("This Port code already included", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const deleteRow = (event) => {
    event.preventDefault();
    axios.delete(
      `${BASE_URL}${pageComponent}/${selectRowData[0].id}/destroy`,
      selectRowData[0].id
    );
    toast.warning("Successfully Deleted Data Row", {
      position: toast.POSITION.TOP_RIGHT,
    });
    setTimeout(window.location.reload.bind(window.location), 2000);
  };

  const tTitle = [
    "Country Code",
    "Country Name",
    "Port Code",
    "Port Description",
    "International Port Code",
  ];
  const columns = [
    "country_code",
    "country_description",
    "port_code",
    "port_description",
    "international_port_code",
  ];

  const handleButtonClickPDF = () => {
    if (!Array.isArray(data) || data.length === 0 || !Array.isArray(columns) || columns.length === 0) {
      // Handle the scenario where the data or selected keys are invalid or empty
      toast.error("Invalid data or selected keys for export.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const filteredRows = data.map(obj => {
      const filteredRow = {};
      columns.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          filteredRow[key] = obj[key];
        }
      });
      return filteredRow;
    });

    const doc = new jsPDF();
    const rows = filteredRows.map(obj => Object.values(obj));

    const columnStyles = {}; // Object to hold column styles

    // Set cell widths (adjust widths as needed)
    columns.forEach(key => {
      columnStyles[key] = { cellWidth: 30 }; // Change width as per your requirement
    });

    doc.autoTable({
      columns: tTitle.map(key => ({ header: key, dataKey: key })),
      body: rows,
      columnStyles,
      startY: 5, // Adjust the starting Y position for the table
      // ... other configuration options
    });

    // Save the PDF file
    const dateTime = new Date().toISOString().replace(/[-T:.Z]/g, '');
    const fileName = `Ports_PDF_Report_${dateTime}.pdf`;
    doc.save(fileName);
  };
  const countryOptions = countryList ?
    countryList.map((countryOptionItem) => ({
      value: countryOptionItem.id,
      label: countryOptionItem.country_description,
    })) : [];

  return (
    <Container fluid>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-3 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Country   </Form.Label>
                  <SelectDropdown
                    options={countryOptions}
                    onChange={setCountryCode}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Port Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="0001"
                    name="protCode"
                    value={protCode}
                    readOnly={selectRowData !== "" ? true : false}
                    className={emptyProtCode === true ? "border-red2" : ""}
                    onChange={(e) => setProtCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Port Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="protDesc"
                    value={protDesc}
                    className={emptyPortName === true ? "border-red2" : ""}
                    onChange={(e) => setProtDesc(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Port Code For XML</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="protIntCode"
                    value={protIntCode}
                    className={
                      emptyInputProtCodeXML === true ? "border-red2" : ""
                    }
                    onChange={(e) => setprotIntCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="text-center">
              <Col className="text-end">
                {props.selectedAuthority && props.selectedAuthority.new === 1 ? (
                  <>
                    <Button
                      className="ms-3"
                      variant="primary"
                      onClick={selectRowData !== "" ? edditRow : handleSave}
                      disabled={btnActive}
                    >
                      Save
                    </Button>

                    <Button
                      className="ms-3"
                      variant="primary"
                      onClick={createNewRow}
                    >
                      New
                    </Button>
                  </>
                ) : null}

                {props.selectedAuthority && props.selectedAuthority.edit === 1 ? (
                  <Button
                    className="ms-3"
                    variant="primary"
                    onClick={edditRow}
                    disabled={btnActive}
                  >
                    Update
                  </Button>
                ) : null}

                {props.selectedAuthority && props.selectedAuthority.delete === 1 ? (
                  <Button
                    className="ms-3"
                    variant="primary"
                    onClick={deleteRow}
                    disabled={btnActive}
                  >
                    Delete
                  </Button>
                ) : null}

                {props.selectedAuthority && props.selectedAuthority.print === 1 ? (
                  <Button className="ms-3" variant="primary" onClick={handleButtonClickPDF}>
                    Print
                  </Button>
                ) : null}

                {/* <Button className="ms-3" variant="primary" type="submit">
                  Cancel
                </Button> */}
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <TableView
            data={data}
            columns={columns}
            tTitle={tTitle}
            setSelectedRow={setSelectedRow}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Ports;
